(() => {
  angular
    .module('gm.common.invoices')
    .factory('gmInvoices', gmInvoicesFactory);

  function gmInvoicesFactory(
    Gmy2FA,
    gmApi,
    GmyVaults,
    Upload,
    GmyToken
  ) {
    'ngInject';

    const INVOICE_STATUSES = {
      DRAFT: 'draft',
      PAID: 'paid',
      SENT: 'sent',
      DISPUTED: 'disputed',
      REJECTED: 'rejected',
      REFUNDED: 'refunded',
      EXPIRED: 'expired'
    };

    const DISPUTE_STATUSES = {
      PENDING: 'Pending',
      ESCALATED: 'Escalated',
      REBUTTED: 'Rebutted',
      REFUNDED: 'Refunded',
      REJECTED: 'Rejected'
    };

    const DISPUTE_TYPES = [
      { name: 'Not Delivered', id: 'NotDelivered' },
      { name: 'Not As Described', id: 'NotAsDescribed' },
      { name: 'Fraud', id: 'Fraud' },
      { name: 'Other', id: 'Other' }
    ];

    function callDisputeEndpoint(form, endpointUrl) {
      const files = form.attachments;
      const formCopy = angular.copy(form);

      delete formCopy.attachments;

      const data = Upload.json(formCopy);

      return Upload.upload({
        url: `${gmApi.getApiBasePath()}${endpointUrl}`,
        data: {
          data,
          files
        },
        method: 'POST',
        headers: { 'X-Auth-Token': GmyToken.getToken() }
      });
    }

    return {
      INVOICE_STATUSES,
      DISPUTE_STATUSES,
      DISPUTE_TYPES,

      getExportCSVUrl() {
        return `${gmApi.getApiBasePath()}users/invoices/exportMerchantInvoices`;
      },

      getInvoiceById(invoiceId, isAuthed = true) {
        return gmApi.get(`users/invoices/${invoiceId}`, { auth: isAuthed })
          .then((invoice) => {
            if (invoice.actualVaultId) {
              GmyVaults.getVaultById(invoice.actualVaultId).then((vault) => {
                invoice.actualVault = vault;
              });
            } else {
              invoice.actualVault = null;
            }

            invoice.products = invoice.products.map(p => ({
              productId: p.productId,
              imageBaseUrl: p.imageBaseUrl,
              price: p.price,
              quantity: p.quantity,
              product: {
                id: p.productId,
                details: p.product
              }
            }));

            return invoice;
          });
      },

      getInvoiceSums(products, shippingPrice, taxPercentage) {
        const data = {
          products,
          shippingPrice,
          taxPercentage
        };

        return gmApi
          .post('users/invoices/price', data, { auth: true })
          .then(_data => _data.price);
      },

      getOutgoingInvoices(recipientEmail = null, recipientPhone = null) {
        return gmApi
          .get('users/invoices/out', { params: { recipientEmail, recipientPhone } })
          .then(({ userInvoices }) => userInvoices);
      },

      rebutInvoiceDispute(invoiceId, rebut) {
        return callDisputeEndpoint(rebut, `users/invoices/rebut/${invoiceId}`);
      },

      refundInvoice(invoiceId) {
        return Gmy2FA.executeWith2FA(twoFactAuth =>
          gmApi.post(`users/invoices/refund/${invoiceId}`, null, { auth: true, twoFactAuth })
        );
      },

      removeInvoice(invoiceId) {
        return gmApi.delete(`users/invoices/${invoiceId}`, { auth: true });
      },

      saveCheckoutInvoice(invoice) {
        return gmApi.post('users/invoices/checkout', invoice, { auth: true });
      },

      saveInvoice(invoice) {
        return gmApi.post('users/invoices/business', invoice, { auth: true });
      },

      sendInvoiceById(invoiceId) {
        return gmApi.put(`users/invoices/${invoiceId}`, null, { auth: true });
      },

      startInvoiceDispute(invoiceId, dispute) {
        return callDisputeEndpoint(dispute, `users/invoices/dispute/${invoiceId}`);
      }
    };
  }
})();
